import { render } from "./PaywallInterface.vue?vue&type=template&id=6e609734"
import script from "./PaywallInterface.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallInterface.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallInterface.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e609734"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e609734', __exports__)) {
    api.reload('6e609734', __exports__)
  }
  
  module.hot.accept("./PaywallInterface.vue?vue&type=template&id=6e609734", () => {
    api.rerender('6e609734', render)
  })

}


export default __exports__